module.exports = __webpack_public_path__ + "static/media/ocorrence_icon.33745df5.svg";